import React from 'react';

import { SEARCH_PAGE_Z_INDEX } from '@rover/constants/src/search/searchPage.constants';
import { Flex } from '@rover/kibble/core';

import AdvancedFiltersButton from './AdvancedFiltersButton';

export type Props = {
  selectedFilterCount: number;
  onClick: () => void;
};

export default ({ ...other }: Props): JSX.Element => (
  <Flex
    display={['flex', 'none']}
    position="fixed"
    bottom="6x"
    // Anchored bottom-left so it cannot overlap the shortlist pill fixed at
    // bottom-right (DEV-155722).
    left="4x"
    zIndex={SEARCH_PAGE_Z_INDEX.ADVANCED_FILTER_BUTTON_FIXED.toString()}
  >
    {/* 56px matches the shortlist pill across the screen: its 32px avatar stack
        plus the default button's 10px vertical padding and 2px borders. */}
    <AdvancedFiltersButton variant="primary" height="56px" {...other} />
  </Flex>
);
